import API from "../api/axios";

// agents
export const fetchAgentsAPI = () => API.get("/agents");

// logs
export const fetchLogsAPI = ({ agent, status, dates }) => {
   let params = {};

   if (agent) params.agent = agent;
   if (status) params.status = status;

   if (dates.length === 2) {
      params.fromDate = dates[0].format("YYYY-MM-DD");
      params.toDate = dates[1].format("YYYY-MM-DD");
   }

   return API.get("/telecmi/call-logs", { params });
};

// call
export const makeCallAPI = (data) =>
   API.post("/telecmi/call", data);